import React, { useEffect, Suspense } from "react";
import ScrollToTop from "react-scroll-to-top";
import useAuth from "../hooks/useAuth";
import WebUrlRoutes from "../routes";
import FallBackLoader from "../components/FallBackLoader";
import { useWebSettings } from "../hooks/useQuery/useWebsiteSettings";
import AuthenticateUser from "./AuthenticateUser";
import { setDocumentStyles } from "../utils/documentStyles";

export const MainPage = ({ notVerified }) => {
  const { token, currentUser, userLogin, setWebSettings } = useAuth();
  const { isLoading, data, refetch } = useWebSettings(
    currentUser?.organization?.uuid
  );

  useEffect(() => {
    userLogin();
    //  eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (currentUser) {
      refetch();
    }
    //  eslint-disable-next-line
  }, [currentUser]);

  useEffect(() => {
    if (data?.data && !notVerified) {
      setWebSettings(data?.data);
      setDocumentStyles(data?.data);
    }
    //  eslint-disable-next-line
  }, [data]);
  return (
    <>
      {token !== "" || token !== undefined || !isLoading ? (
        <Suspense fallback={<FallBackLoader />}>
          <WebUrlRoutes />
          <div className="container-fluid position-relative">
            <ScrollToTop
              smooth
              top={90}
              color="white"
              viewBox="0 -5 14 20"
              svgPath="M11.4,7.7l-4.9-5l-4.9,5c-0.4,0.4-0.9,0.4-1.3,0l0,0c-0.4-0.4-0.4-0.9,0-1.3L6.5,0l6.2,6.4c0.4,0.4,0.3,0.9,0,1.3l0,0 C12.4,8.1,11.8,8.1,11.4,7.7z"
            />
          </div>
        </Suspense>
      ) : (
        <AuthenticateUser />
      )}
    </>
  );
};
